import React, { useState, useEffect } from "react";
import NavbarDev, { loadNav } from "./Navbar";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { Trash2, SquarePen, KeyRound } from "lucide-react";

const RowPC = ({ data }) => {
    return (
        <div className="grid grid-cols-3 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
            <div className="flex items-center pl-2 ">
                {data.value.Nome}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Cognome}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Email}
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Venditori = () => {
    const [isLoading, setIsLoading] = useState(false);
    const headers = [
        { label: 'Nome', key: 'Nome' },
        { label: 'Riferimento', key: 'Cognome' },
        { label: 'Email', key: 'Email' }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [dataAdd, setDataAdd] = useState({});
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [dataRow, setDataRow] = useState(null);
    const [needConfirmRow, setNeedConfirmRow] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
    const [dataPassword, setDataPassword] = useState({});
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        try {
            await loadNav();

            const r2 = await fetch("/getVenditori", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/dev/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                console.log(rd2);
                setDataTable(rd2.map(item => ({ value: item })));
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprova più tardi", onClose: () => { navigate("/dev/dash"); }, needConfirm: false });
            setShowAlert(true);
        }

        setIsLoading(false);
    };

    const checkEmail = async (isAdd) => {
        let email = isAdd ? dataAdd["Email"] : dataRow.value["Email"];
        if (email.trim() === "" || email === null) return;

        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 401) {
                const data = await response.json();
                setAlertInfo({ type: "error", text: data['error'], onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
                if (isAdd) {
                    setDataAdd(prev => ({ ...prev, Email: '' }));
                } else {
                    setDataRow(prev => ({ ...prev, value: { ...prev.value, Email: '' } }));
                }
            }
            else if (response.status !== 200) {
                const data = await response.json();
                console.error(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nel controllo della mail, riprovare più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }

    };

    const confirmPopUpAdd = async () => {
        //Controllo che la nuova password e la conferma password siano uguali
        if (dataAdd["Password"] !== dataAdd["ConfermaPassword"]) {
            setAlertInfo({ type: "warning", text: "Le password non coincidono", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            setDataAdd(prev => ({ ...prev, Password: '', ConfermaPassword: '' }));
            return;
        }

        if (!dataAdd["Nome"] || !dataAdd["Cognome"] || !dataAdd["Email"] || !dataAdd["Password"] || !dataAdd["ConfermaPassword"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const r = await fetch('/addUser', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Nome: dataAdd["Nome"],
                    Cognome: dataAdd["Cognome"],
                    Email: dataAdd["Email"],
                    Password: dataAdd["Password"],
                    Livello: "Venditore",
                    CodiceDominio: null,
                    Stato: "Attivo"
                })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.error(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta del venditore, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            console.error(error);
        }
        setIsLoading(false);
    };

    const confirmPopUpModifica = async () => {
        if (!dataRow.value["Cognome"] || !dataRow.value["Email"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const r1 = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: dataRow.value["ID"],
                    Nome: dataRow.value["Nome"],
                    Cognome: dataRow.value["Cognome"],
                    Email: dataRow.value["Email"],
                })
            });
            if (r1.status === 500) {
                const rd1 = await r1.json();
                console.error(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica dell'installatore, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/eliminaVenditore', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ID: dataRow.value["ID"]
                    })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.error(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nell'eliminazione del venditore, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare il venditore? Questa azione sarà irreversibile", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpPassword = async () => {
        if (dataPassword["Password"] !== dataPassword["ConfermaPassword"]) {
            setAlertInfo({ type: "warning", text: "Le password non coincidono", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            setDataPassword({ Password: '', ConfermaPassword: '' });
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: dataRow.value["ID"],
                    Password: dataPassword["Password"]
                })
            });
            if (response.status === 500) {
                const responseData = await response.json();
                console.error(responseData.error);
                setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nel cambio password, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarDev page={"VENDITORI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={["Nome", "Email"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    clickableRow={true}
                    archiveClickable={false}
                    actionRow={(row, rowIndex, showArchived) => {
                        setIsRowInfoVisible(true); setDataRow(row); setNeedConfirmRow(false);
                    }}
                    classes="mt-2"
                    needAdd={true}
                    addAction={() => setIsAddVisible(true)}
                />
                <PopUp title={"Aggiungi Venditore"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpAdd}
                    cancelAction={() => { setIsAddVisible(false); setDataAdd({}); }}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Nome *"
                            value={dataAdd["Nome"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Nome: value }))}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            info={true}
                            infotext='Il nome è quello che verrà mostrato in fase di creazione delle licenze'
                            infopos="l"
                        />
                        <Input
                            label="Riferimento *"
                            value={dataAdd["Cognome"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Cognome: value }))}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Email *"
                            value={dataAdd["Email"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Email: value }))}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            blurAction={() => checkEmail(true)}
                        />
                        {!dataAdd.Password && (<Button type="hollow" color="blue" classes="w-[80%] md:w-[70%] mt-2" onClick={() => {
                            setDataAdd(prev => ({ ...prev, Password: "PSWProva123", ConfermaPassword: "PSWProva123" }));
                        }}>
                            Utilizza password "PSWProva123"
                        </Button>)}
                        <Input
                            label="Password *"
                            value={dataAdd["Password"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Password: value }))}
                            type="password"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Conferma Password *"
                            value={dataAdd["ConfermaPassword"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, ConfermaPassword: value }))}
                            type="password"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
                <PopUp title={needConfirmRow ? "Modifica Informazioni Venditore" : ""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={needConfirmRow}
                    confirmAction={confirmPopUpModifica}
                    cancelAction={() => { setIsRowInfoVisible(false); setDataRow(null); setNeedConfirmRow(false); }}
                >
                    {needConfirmRow && (
                        <div className="flex flex-col items-center">
                            <Input
                                label="Riferimento *"
                                value={dataRow.value["Cognome"]}
                                setValue={(value) => setDataRow(prev => ({ ...prev, value: { ...prev.value, Cognome: value } }))}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Email *"
                                value={dataRow.value["Email"]}
                                setValue={(value) => setDataRow(prev => ({ ...prev, value: { ...prev.value, Email: value } }))}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                                blurAction={() => checkEmail(false)}
                            />
                        </div>
                    )}
                    {!needConfirmRow && (
                        <>
                            <div className="grid grid-cols-2 mt-2 gap-2">
                                <Button type="hollow" onClick={handleElimina}>
                                    ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                                <Button type="hollow" onClick={() => setNeedConfirmRow(true)}>
                                    MODIFICA DATI <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                            </div>
                            <Button type="hollow" onClick={() => setIsChangePasswordOpen(true)} classes="flex justify-self-center mt-2">
                                CAMBIA PASSWORD <KeyRound size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </>
                    )}
                </PopUp>
                <PopUp title={"Cambia password"}
                    isVisible={isChangePasswordOpen}
                    setIsVisible={setIsChangePasswordOpen}
                    needConfirm={true}
                    confirmAction={confirmPopUpPassword}
                    cancelAction={() => setIsChangePasswordOpen(false)}
                >
                    <>
                        <div className="flex flex-col items-center">
                            <div className="w-[80%] md:w-[70%] mt-2">
                                {dataPassword && !dataPassword.Password && (<Button type="hollow" color="blue" classes="w-full" onClick={() => {
                                    setDataPassword({ Password: "PSWProva123", ConfermaPassword: "PSWProva123" });
                                }}>
                                    Utilizza password "PSWProva123"
                                </Button>)}
                                <Input
                                    label="Password *"
                                    value={dataPassword["Password"] || ""}
                                    setValue={(value) => setDataPassword(prev => ({ ...prev, Password: value }))}
                                    type="password"
                                    classes="mt-2"
                                />
                                <Input
                                    label="Conferma Password *"
                                    type="password"
                                    value={dataPassword["ConfermaPassword"] || ""}
                                    setValue={(value) => setDataPassword(prev => ({ ...prev, ConfermaPassword: value }))}
                                    classes="mt-2"
                                />
                            </div>
                        </div>
                    </>
                </PopUp>
            </div >
        </div >
    )
};
export default Venditori;